import styled from '@emotion/styled'

import { Fee, Icon, MessageBox, Space, Typography } from '@/components/core-v2'

const StyledNoFeeBoxWrapper = styled.div`
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  & > div {
    width: 100%;
  }
`

const StyledFeeBox = styled(Space)<{ highlighted: boolean }>`
  background: ${({ highlighted }) => (highlighted ? 'var(--InfoBG)' : 'transparent')};
`

const StyledFeeRow = styled(Space)<{ hasBorder?: boolean; isTitle?: boolean }>`
  border-bottom: ${({ hasBorder, isTitle }) =>
    hasBorder ? `1px solid var(--White${isTitle ? '80' : '90'})` : 'none'};
`

const FeeDataRow = ({
  hasBorder = true,
  highlighted,
  isTitle,
  propertyName,
  value
}: {
  hasBorder?: boolean
  highlighted: boolean
  isTitle?: boolean
  propertyName: string
  value: string | boolean | number
}) => (
  <StyledFeeRow
    isflex
    flexGrow={1}
    hasBorder={hasBorder}
    isTitle={isTitle}
    justifyContent="space-between"
    p={4}
  >
    <Typography
      fontSize="13px"
      fontWeight={highlighted ? 'bold' : 'normal'}
      textAlign="center"
      variant="b3"
    >
      {propertyName}
    </Typography>
    <Typography
      fontSize="13px"
      fontWeight={highlighted ? 'bold' : 'normal'}
      textAlign="center"
      variant="b3"
    >
      {value}
    </Typography>
  </StyledFeeRow>
)

export const ProposedChangesModalFeeTable = ({
  fees,
  highlighted
}: {
  fees: Fee[]
  highlighted: boolean
}) =>
  fees.length ? (
    <Space isflex flexDirection="column" flexGrow={1} p={4}>
      <Space {...(highlighted ? { my: 4 } : { mt: 4, mb: 0 })}>
        <Typography fontSize="13px" fontWeight="bold" variant="b3">
          Fees
        </Typography>
      </Space>
      {fees.map(fee => (
        <StyledFeeBox
          key={`modal-fee-${fee.name}`}
          aria-label={highlighted ? 'Changed fee' : 'Fee'}
          data-testid="proposed-changes-modal-fee"
          flexGrow={1}
          highlighted={highlighted}
          mb={highlighted ? 5 : 3}
          p={highlighted ? 3 : 1}
        >
          <Space isflex flexDirection="column" flexGrow={1}>
            <StyledFeeRow isTitle isflex flexGrow={1} hasBorder={!!true} p={4}>
              <Typography
                fontSize="13px"
                fontWeight={highlighted ? 'bold' : 'normal'}
                textAlign="center"
                variant="b3"
              >
                {fee.name}
              </Typography>
            </StyledFeeRow>
            <FeeDataRow
              highlighted={highlighted}
              propertyName="Calculated on"
              value={fee.calculatedOn}
            />
            <FeeDataRow highlighted={highlighted} propertyName="Frequency" value={fee.frequency} />
            <FeeDataRow
              highlighted={highlighted}
              propertyName="Vat"
              value={fee.isVatApplicable ? 'Yes' : 'No'}
            />
            <FeeDataRow
              highlighted={highlighted}
              propertyName="Counterparty"
              value={fee.counterpartyId}
            />
            <FeeDataRow
              hasBorder={false}
              highlighted={highlighted}
              propertyName="Rate (%)"
              value={fee.rate}
            />
          </Space>
        </StyledFeeBox>
      ))}
    </Space>
  ) : (
    <StyledNoFeeBoxWrapper>
      <MessageBox state="null">
        <Space isflex alignItems="center">
          <Space isflex alignItems="center" mr={2}>
            <Icon name="circleInfo" size="default" />
          </Space>
          No fees applied
        </Space>
      </MessageBox>
    </StyledNoFeeBoxWrapper>
  )
